import { QuestionType } from './question-type.enum';
import { QuestionView } from './question-view.model';

export interface FormSummary {
  sections: number;
  questions: number;
  required: number;
}

export function formSummaryFor(elements: QuestionView[]): FormSummary {
  const all = elements ?? [];
  // Sections, titles and helper text lay a form out rather than ask anything.
  const questions = all.filter(
    element =>
      element.questionType !== QuestionType.Section &&
      element.questionType !== QuestionType.Title &&
      element.questionType !== QuestionType.HelperText
  );

  return {
    sections: all.filter(element => element.questionType === QuestionType.Section).length,
    questions: questions.length,
    required: questions.filter(question => question.isRequired).length
  };
}
